export default __webpack_public_path__ + "159e43dcb3cdf3be99c28c8960b3d655.jpg";